import client from '@api/client';

export const sendAmazonProfile = (profile) => {
  return client.post('/payments/amazonprofile', {
    profile: profile,
  });
};

export const amazonPay = (amazonAccountId) => {
  return client.post('/payments/amazon-pay', {
    amazonAccountId,
  });
};
